import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  //Tab组件里, sectionComponent.child.current 是对应的渲染分选组件
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ componentDefaultValue });

  sectionComponent.child.map((child, i) => {
    if (child.current != null) {
      child.current?.setState({ searchParameter: { moduleId: parameter }, moduleId: parameter });
      child.current?.child.current?.setState({ moduleId: parameter });

      child.current?.customForm.current?.setState({ componentDefaultValue: [], componentDataSource: [] });
      setTimeout(() => {
        child.current?.getSectionDataByDefault();
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function manageChecklistTemplateFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'ChecklistTemplate') {
      child.current?.child.current?.setState({ manageFolderShow: true });
      setTimeout(() => {
        child.current?.child.current?.manageFolder.current?.getChecklistTemplateFolderList();
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function openManageGroup({ component, checklistTemplateFolderId } = {}) {
  component.setState({ checklistTemplateFolderId: checklistTemplateFolderId, manageGroupShow: true });
  setTimeout(() => {
    component.manageGroup.current?.getChecklistTemplateGroupList();
  }, config.setTimeoutMilliSecond);
}

//删除Folder (Section头部删除按钮调用), 成功后刷新Section数据
export function deleteFolder({ component, key } = {}) {
  httpClient
    .delete('Admin/ChecklistTemplateFolder/' + key)
    .then(({ data }) => {
      if (data.result) {
        component.getSectionDataByDefault();
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, component.props.pageComponent);
    });
}

//删除Group (Section头部删除按钮调用), 成功后刷新Section数据
export function deleteGroup({ component, key } = {}) {
  httpClient
    .delete('Admin/ChecklistTemplateGroup/' + key)
    .then(({ data }) => {
      if (data.result) {
        component.getSectionDataByDefault();
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, component.props.pageComponent);
    });
}

export function addChecklistTemplate({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    sectionComponent.customForm.current?.getComponentDataSource();

    //设置默认选择的Folder和Group
    let formData = parameter;
    //设置富文本的控件为空字符串，否则会崩
    formData['Comments'] = '';
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });

    setTimeout(() => {
      //ChecklistStatusSetId设置备选项里第一个
      if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'] !== undefined) {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'][0].Value);
      }
      //设置联动的Select
      getChecklistTemplateGroupSelectOptionList({ sectionName: sectionName, parameter: parameter.ChecklistTemplateFolderId, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function collapseAllGroups({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'ChecklistTemplate') {
      let data = child.current?.child.current?.state.data.map((folder, i) => {
        folder.ChecklistTemplateGroupList.map((group, i) => {
          group.Collapsed = true;
          return group;
        });
        return folder;
      });
      setTimeout(() => {
        child.current?.child.current?.setState({ data });
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function collapseFolder({ component, key } = {}) {
  let data = component.state.data.map((folder, i) => {
    if (folder.key === key) {
      if (folder.Collapsed !== true) {
        folder.Collapsed = true;
      } else {
        folder.Collapsed = false;
      }
    }
    return folder;
  });
  component.setState({ data });
}

export function collapseGroup({ component, key } = {}) {
  let data = component.state.data.map((folder, i) => {
    folder.ChecklistTemplateGroupList.map((group, j) => {
      if (group.key === key) {
        if (group.Collapsed !== true) {
          group.Collapsed = true;
        } else {
          group.Collapsed = false;
        }
      }
      return group;
    });
    return folder;
  });
  component.setState({ data });
}

export function getChecklistTemplateGroupSelectOptionList({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('Admin/ChecklistTemplateGroup/GetSelectOptionList?moduleId=' + formComponent.props.moduleId + (parameter !== null ? '&parameterId=' + parameter : ''))
    .then(({ data }) => {
      if (data.result) {
        let dataSource = data.data;
        let componentDataSource = { ...formComponent.state.componentDataSource };
        dataSource = dataSource.filter(item => item.Value !== 0);
        componentDataSource['ChecklistTemplateGroupId'] = dataSource;
        formComponent.setState({ componentDataSource });
        if (dataSource.length > 0) {
          if (dataSource.filter(item => item.Value === sectionComponent.customForm.current?.formRef.current?.getFieldValue('ChecklistTemplateGroupId')).length === 0) {
            //搜到的数据源不包括当前值, 说明更换了Folder, Group选择新Folder里第一个值
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistTemplateGroupId', dataSource[0].Value);
          } else {
            //否则选择当前值
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistTemplateGroupId', sectionComponent.customForm.current?.formRef.current?.getFieldValue('ChecklistTemplateGroupId'));
          }
        } else {
          //搜不到数据源, 移除Group
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistTemplateGroupId', null);
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function customFormOnSubmit({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ customFormSubmitting: true });
  let areaName = sectionComponent.props.areaName;
  let pageName = sectionComponent.props.pageName;
  let form = formComponent.formRef.current?.getFieldsValue();

  if (parameter !== undefined) {
    for (let key in parameter) {
      form[key] = parameter[key];
    }
  }

  form.key = formComponent.state.currentDataKey;
  console.log(sectionComponent.state.componentType + ' 提交的表单', form);

  switch (sectionComponent.state.componentType) {
    case 'Create':
      httpClient
        .post(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            sectionComponent.setState({ customFormSubmitting: false });
            setTimeout(() => {
              formComponent.resetFields();
              sectionComponent.setState({ showModal: false });
              let updatedData = JSON.parse(JSON.stringify(sectionComponent.child.current?.state.data));
              let isGroupFound = false;
              for (let section of updatedData) {
                // 遍历ChecklistTemplateGroupList
                for (let group of section.ChecklistTemplateGroupList) {
                  // 找到与给定ChecklistTemplateGroupId匹配的group
                  if (group.key === data.data.ChecklistTemplateGroupId) {
                    // 向ChecklistTemplateList数组中添加新的ChecklistTemplate
                    if (Array.isArray(group.ChecklistTemplateList)) {
                      group.ChecklistTemplateList.push(data.data);
                    } else {
                      // 如果ChecklistTemplateList不存在或不是数组，则初始化并添加
                      group.ChecklistTemplateList = [data.data];
                    }
                    isGroupFound = true;
                    break;  // 如果找到并添加了ChecklistTemplate，则退出循环
                  }
                }
                if (isGroupFound) break;
              }
              sectionComponent.child.current?.setState({ data: updatedData });

              let checklistTemplateIds = [];
              updatedData.map(folder => {
                folder.ChecklistTemplateGroupList.map(group => {
                  group.ChecklistTemplateList.map(checklistTemplate => {
                    checklistTemplateIds.push(checklistTemplate.ChecklistTemplateId);
                  })
                })
              });
              if (checklistTemplateIds.length < 2) {
                sectionComponent.setState({ previousButtonDisabled: true, nextButtonDisabled: true });
              } else {
                sectionComponent.setState({ previousButtonDisabled: false, nextButtonDisabled: false });
              }

            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data);
            sectionComponent.setState({ customFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ customFormSubmitting: false });
        });
      break;
    case 'Edit':
      httpClient
        .put(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            sectionComponent.setState({ customFormSubmitting: false });
            setTimeout(() => {
              if (sectionComponent.state.closeModelAfterSubmit !== false) {
                formComponent.resetFields();
                sectionComponent.setState({ showModal: false });
              }
              let updatedData = JSON.parse(JSON.stringify(sectionComponent.child.current?.state.data));
              let isGroupFound = false;

              // 假设 data.data 包含了更新的 checklistTemplate 信息
              const newChecklistTemplate = data.data;
              const newChecklistTemplateGroupId = newChecklistTemplate.ChecklistTemplateGroupId; // 获取新的组ID
              let oldChecklistTemplateGroupId;

              updatedData.map(section => {
                section.ChecklistTemplateGroupList.map(group => {
                  group.ChecklistTemplateList.filter(checklistTemplate => {
                    if (checklistTemplate.key === newChecklistTemplate.key) {
                      oldChecklistTemplateGroupId = group.ChecklistTemplateGroupId; // 获取旧的组ID
                    }
                  })
                })
              });

              //判断是否换组了
              if (newChecklistTemplateGroupId === oldChecklistTemplateGroupId) {
                //没有换组, 直接替换原数据
                updatedData = updatedData.map(section => {
                  return { // 确保返回更新后的 section
                    ...section,
                    ChecklistTemplateGroupList: section.ChecklistTemplateGroupList.map(group => {
                      return { // 确保返回更新后的 group
                        ...group,
                        ChecklistTemplateList: group.ChecklistTemplateList.map(checklistTemplate => {
                          if (checklistTemplate.key === newChecklistTemplate.key) {
                            return newChecklistTemplate; // 返回新的 checklistTemplate
                          }
                          return checklistTemplate;
                        })
                      };
                    })
                  };
                });
              } else {
                //换组了, 重新分组
                // 首先找到并删除旧的 checklistTemplate
                updatedData = updatedData.map(section => {
                  return {
                    ...section,
                    ChecklistTemplateGroupList: section.ChecklistTemplateGroupList.map(group => {
                      const filteredChecklistTemplates = group.ChecklistTemplateList.filter(checklistTemplate => {
                        if (checklistTemplate.key === newChecklistTemplate.key) {
                          oldChecklistTemplateGroupId = group.ChecklistTemplateGroupId; // 获取旧的组ID
                          return false; // 从旧的组中移除
                        }
                        return true;
                      });
                      return {
                        ...group,
                        ChecklistTemplateList: filteredChecklistTemplates
                      };
                    })
                  };
                });

                // 然后将新的 checklistTemplate 添加到新的组中
                updatedData = updatedData.map(section => {
                  return {
                    ...section,
                    ChecklistTemplateGroupList: section.ChecklistTemplateGroupList.map(group => {
                      if (group.ChecklistTemplateGroupId === newChecklistTemplateGroupId) {
                        return {
                          ...group,
                          ChecklistTemplateList: [...group.ChecklistTemplateList, newChecklistTemplate]
                        };
                      }
                      return group;
                    })
                  };
                });
              }

              sectionComponent.child.current?.setState({ data: updatedData });

            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data);
            sectionComponent.setState({ customFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ customFormSubmitting: false });
        });
      break;
  }
}

export function deleteBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  httpClient
    .delete(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        let updatedData = JSON.parse(JSON.stringify(sectionComponent.child.current?.state.data));
        let isGroupFound = false;

        // 第一步：从数据中找到并删除旧的 checklistTemplate
        const removeOldChecklistTemplate = (data, key) => {
          let found = false; // 用于标记是否找到并删除了旧的 checklistTemplate
          const newData = data.map(section => {
            const newGroupList = section.ChecklistTemplateGroupList.map(group => {
              const newChecklistTemplateList = group.ChecklistTemplateList.filter(checklistTemplate => {
                if (checklistTemplate.key === key) {
                  found = true;
                  return false; // 如果找到了匹配的 key，我们将其从数组中过滤掉
                }
                return true;
              });
              return { ...group, ChecklistTemplateList: newChecklistTemplateList };
            });
            return { ...section, ChecklistTemplateGroupList: newGroupList };
          });
          return { newData, found };
        };
        // 执行删除操作
        const { newData, found } = removeOldChecklistTemplate(updatedData, parameter.key);
        sectionComponent.child.current?.setState({ data: newData });


        let checklistTemplateIds = [];
        newData.map(folder => {
          folder.ChecklistTemplateGroupList.map(group => {
            group.ChecklistTemplateList.map(checklistTemplate => {
              checklistTemplateIds.push(checklistTemplate.ChecklistTemplateId);
            })
          })
        });
      } else {
        if (data.code === 2) {
          message.error(data.message);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}